export default "__VITE_ASSET__DXIuamKa__"